<template>
  <div class="justify-content-center">
    <div class="row addContainer justify-content-center">
      <div class="col-xs-12">
        <form @submit.prevent="handleAddAdmin" class="addForm">
          <select
            name="adminRole"
            id="adminRole"
            class="form-control"
            v-model="role"
            required
          >
            <option v-for="role in rolesToChoose" :key="role" :value="role">
              {{ role }}
            </option>
          </select>
          <input
            type="text"
            class="form-control"
            placeholder="Login"
            v-model="phone"
            required
          />
          <input
            type="text"
            class="form-control"
            placeholder="Imię"
            v-model="firstName"
            required
          />
          <input
            type="text"
            class="form-control"
            placeholder="Telefon"
            v-model="adminPhone"
            required
            minlength="9"
            maxlength="9"
          />
          <input
            type="password"
            class="form-control"
            placeholder="Hasło"
            v-model="password"
            required
          />
          <input
            type="password"
            class="form-control"
            placeholder="Powtórz Hasło"
            v-model="repassword"
            required
          />
          <button
            type="submit"
            class="btn btn-outline-dark"
            :disabled="addingAdmin"
          >
            {{ addingAdmin ? "Dodawanie..." : "Dodaj" }}
          </button>
        </form>
      </div>
    </div>
    <div
      class="row justify-content-center"
      v-if="userRole === 'ADMIN' || userRole === 'ADMIN1'"
    >
      <div class="col-xs-12">
        <table class="table borderless serviceTable">
          <thead>
            <tr class="tr-table">
              <th scope="col">Login</th>
              <th scope="col">Imię</th>
              <th scope="col">Rola</th>
              <th scope="col">Telefon</th>
              <th scope="col">Edytuj</th>
              <th scope="col">Usuń</th>
              <th scope="col">Dostęp do DOD</th>
              <th scope="col">Dostęp do POD</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="admin in admins" :key="admin.id">
              <td>{{ admin.phone }}</td>
              <td>{{ admin.first_name }}</td>
              <td>{{ admin.role }}</td>
              <td>{{ admin.admin_phone }}</td>
              <td>
                <button
                  data-toggle="modal"
                  data-target="#editAdmin"
                  class="btn btn-outline-dark btn-sm"
                  @click="setDataToEdit(admin)"
                >
                  Edytuj
                </button>
              </td>
              <td>
                <button
                  class="btn btn-outline-dark btn-sm"
                  @click="removeAdmin(admin)"
                >
                  Usuń
                </button>
              </td>
              <td>
                <input
                  v-if="!loading"
                  @change="handleDodCheckboxForAdmin(admin)"
                  type="checkbox"
                  v-model="dodAccess[admin.id]"
                />
              </td>
              <td>
                <input
                  v-if="!loading"
                  @change="handlePodCheckboxForAdmin(admin)"
                  type="checkbox"
                  v-model="podAccess[admin.id]"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="modal fade"
      id="editAdmin"
      tabindex="-1"
      role="dialog"
      aria-labelledby="editAdmin"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editAdmin">Zmiana hasła</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body messagesBody">
            <form @submit.prevent="handleEditAdmin" class="addForm">
              <h4>Edycja konta</h4>
              <select
                name="adminRoleEdit"
                id="adminRoleEdit"
                class="form-control"
                v-model="editRole"
                required
              >
                <option v-for="role in rolesToChoose" :key="role" :value="role">
                  {{ role }}
                </option>
              </select>
              <input
                type="text"
                class="form-control"
                placeholder="Login"
                v-model="editPhone"
                required
              />
              <input
                type="text"
                class="form-control"
                placeholder="Imię"
                v-model="editFirstName"
                required
              />
              <input
                type="text"
                class="form-control"
                placeholder="Telefon"
                v-model="editAdminPhone"
                required
                minlength="9"
                maxlength="9"
              />
              <input
                type="password"
                class="form-control"
                placeholder="Hasło"
                v-model="editPassword"
                required
              />
              <input
                type="password"
                class="form-control"
                placeholder="Powtórz Hasło"
                v-model="Repassword"
                required
              />
              <button type="submit" class="btn btn-outline-dark">Zapisz</button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../axios";
export default {
  name: "AddAdmin",
  data() {
    return {
      rolesToChoose: ["ADMIN1", "ADMIN2", "ADMIN3"],
      phone: "",
      password: "",
      role: "ADMIN2",
      firstName: "",
      editPhone: "",
      editPassword: "",
      editRole: "",
      editFirstName: "",
      editAdminId: "",
      editAdminPhone: "",
      adminPhone: "",
      dodAccess: {},
      podAccess: {},
      loading: true,
      addingAdmin: false,
    };
  },

  async created() {
    await this.$store.dispatch("fetchAllAdmins");
    this.admins.forEach((admin) => {
      this.dodAccess[admin.id] = admin.has_dod_access ? true : false;
      this.podAccess[admin.id] = admin.has_pod_access ? true : false;
    });
    this.loading = false;
  },
  computed: {
    admins() {
      return this.$store.getters.getAllAdmins;
    },
    userRole() {
      return this.$store.getters.getUserRole;
    },
  },
  watch: {
    adminPhone() {
      this.adminPhone = this.adminPhone.replace(/[^0-9]/g, "");
    },
    editAdminPhone() {
      this.editAdminPhone = this.editAdminPhone.replace(/[^0-9]/g, "");
    },
  },
  methods: {
    async handleDodCheckboxForAdmin(admin) {
      await axios.put(`api/admin/edit/${admin.id}`, {
        has_dod_access: this.dodAccess[admin.id],
        role: admin.role,
      });
    },
    async handlePodCheckboxForAdmin(admin) {
      await axios.put(`api/admin/edit/${admin.id}`, {
        has_pod_access: this.podAccess[admin.id],
        role: admin.role,
      });
    },
    removeAdmin(admin) {
      const confirmed = prompt(
        `Czy na pewno usunąć konto tego admina? Potwierdź wpisując 'TAK'`,
        ""
      );
      if (confirmed === "TAK") {
        axios
          .put(`api/admin/removeAdmin/${admin.id}`)
          .then(() => {
            this.$notify({
              group: "success",
              text: "Pomyślnie usuniętio konto admina",
            });
            this.$store.dispatch("fetchAllAdmins");
            (this.phone = ""),
              (this.password = ""),
              (this.first_name = ""),
              (this.role = "ADMIN2");
            this.adminPhone = "";
          })
          .catch(() => {
            this.$notify({
              group: "error",
              text: "Nie udało się dodać użytkownika",
            });
          });
      }
    },
    setDataToEdit(admin) {
      this.editPhone = admin.phone;
      this.editRole = admin.role;
      this.editFirstName = admin.first_name;
      this.editAdminId = admin.id;
      this.editAdminPhone = admin.admin_phone;
    },

    checkPassword(password, editPassword) {
      const regex =
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{7,}$/g;
      const isValid = regex.test(password, editPassword);
      return isValid;
    },
    handleAddAdmin() {
      // Bez tej blokady drugie kliknięcie wysyła równoległe żądanie, które przechodzi
      // backendową kontrolę duplikatu loginu i dopiero przy zapisie łamie unique na
      // users.phone - konto powstaje, a operator widzi błąd (raportowany też do Sentry).
      if (this.addingAdmin) {
        return;
      }
      const isValidPassword = this.checkPassword(this.password);
      const pass = this.password == this.repassword;
      if (isValidPassword) {
        if (pass) {
          this.addingAdmin = true;
          axios
            .post(`api/admin/createAdminAccount`, {
              phone: this.phone,
              password: this.password,
              role: this.role,
              first_name: this.firstName,
              admin_phone: this.adminPhone,
            })
            .then(() => {
              this.$notify({
                group: "success",
                text: "Pomyślnie dodano nowego użytkownika",
              });
              this.$store.dispatch("fetchAllAdmins");
              (this.phone = ""),
                (this.password = ""),
                (this.first_name = ""),
                (this.role = "ADMIN2");
              this.adminPhone = "";
            })
            .catch((err) => {
              console.log(err);
              if (
                err.response.data.error ===
                "Admin with this login already exists"
              ) {
                this.$notify({
                  group: "error",
                  text: "Konto admina o takim loginie już istnieje w systemie",
                });
              }
              this.$notify({
                group: "error",
                text: "Nie udało się dodać użytkownika",
              });
            })
            .finally(() => {
              this.addingAdmin = false;
            });
        } else {
          this.$notify({
            group: "error",
            text: "Hasła muszą byś takie same",
          });
        }
      } else {
        this.$notify({
          group: "error",
          text: "Hasło musi zawierać: min. 7 znaków, min. 1 małą literę, min. 1 wielką literę, min. 1 cyfrę oraz min. 1 znak specjalny",
        });
      }
    },

    handleEditAdmin() {
      const isValidPassword = this.checkPassword(this.editPassword);
      const pass = this.editPassword == this.Repassword;
      if (isValidPassword) {
        if (pass) {
          axios
            .put(`api/admin/edit/${this.editAdminId}`, {
              phone: this.editPhone,
              password: this.editPassword,
              role: this.editRole,
              first_name: this.editFirstName,
              admin_phone: this.editAdminPhone,
            })
            .then(() => {
              this.$notify({
                group: "success",
                text: "Pomyślnie zakończono edycję użytkownika",
              });
              this.$store.dispatch("fetchAllAdmins");
            })
            .catch((err) => {
              console.log(err);
              if (
                err.response.data.error ===
                "Admin with this login already exists"
              ) {
                this.$notify({
                  group: "error",
                  text: "Konto admina o takim loginie już istnieje w systemie",
                });
              }
              this.$notify({
                group: "error",
                text: "Nie udało się dodać użytkownika",
              });
            });
        } else {
          this.$notify({
            group: "error",
            text: "Hasła muszą byś takie same",
          });
        }
      } else {
        this.$notify({
          group: "error",
          text: "Hasło musi zawierać: min. 7 znaków, min. 1 małą literę, min. 1 wielką literę, min. 1 cyfrę oraz min. 1 znak specjalny",
        });
      }
    },
  },
};
</script>

<style scoped>
.addContainer button {
  width: 100%;
}
.addForm {
  display: flex;
  flex-direction: column;
  align-items: center;
}
input,
select {
  margin: 10px;
}
</style>
